<template>
  <SettingsWrapper @close="$emit('close')" @save="save">
    <div class="divide-y divide-gray-200 p-6 px-8 py-0">
      <div class="space-y-1">
        <h3 class="text-lg font-medium leading-6 text-gray-900">SMTP options</h3>
        <p class="max-w-2xl text-sm text-gray-500">Control how your emails behave.</p>
      </div>
      <div class="mt-6">
        <dl class="divide-y divide-gray-200">
          <div class="py-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:py-5">
            <dt class="text-sm font-medium text-gray-500">Network</dt>
            <div class="mt-1 sm:mt-0 col-span-4 grid gap-4">
              <div>
                <label for="host" class="block text-sm font-medium text-gray-700">Host</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.host.$model" type="text" name="host" id="host" placeholder="000.000.0.0" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
                <span class="text-sm text-gray-600">
                  Support host name and IP address
                </span>
              </div>
              <div>
                <label
                  for="port"
                  class="block text-sm font-medium text-gray-700"
                >Port</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.port.$model" type="text" name="port" id="port" placeholder="465" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
                <span class="text-sm text-gray-600">
                  Default ports: 25, 465, or 587. Port 465 (SSL required), Port 587 (TLS required)
                </span>
              </div>
              <div>
                <label for="protocol" class="block text-sm font-medium text-gray-700">Protocol</label>
                <div class="mt-1 sm:col-span-2">
                  <div class="relative w-80">
                    <select v-model="$v.protocol.$model" id="protocol" name="protocol" class="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:max-w-xs sm:text-sm">
                      <option value>None</option>
                      <option value="ssl">SSL</option>
                      <option value="tls">TLS</option>
                    </select>
                  </div>
                </div>
                <span class="text-sm text-gray-600">
                  We recommend use security connections: SSL or TLS. Secure Socket Layer (SSL), Transport Layer Security (TLS) protocols.
                </span>
              </div>
            </div>
          </div>
          <div class="py-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:py-5">
            <dt class="text-sm font-medium text-gray-500">Credentials</dt>
            <div class="mt-1 sm:mt-0 grid col-span-4 gap-4">
              <div>
                <label for="authentication-type" class="block text-sm font-medium text-gray-700">Authentication type</label>
                <div class="mt-1 w-full">
                  <div class="relative w-80">
                    <select v-model="$v.authentication_type.$model" id="authentication-type" name="authentication-type" class="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:max-w-xs sm:text-sm">
                      <option value="smtp">None</option>
                      <option value="plain">Plain</option>
                      <option value="login">Login</option>
                      <option value="crammd5">CRAM-MD5</option>
                    </select>
                  </div>
                </div>
                <span class="text-sm text-gray-600">
                  We recommend use security connections: SSL or TLS. Secure Socket Layer (SSL), Transport Layer Security (TLS) protocols.
                </span>
              </div>
              <div>
                <label for="username" class="block text-sm font-medium text-gray-700">Username</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.username.$model" type="text" name="username" id="username" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
              <div>
                <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.password.$model" type="password" name="password" id="password" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
              </div>
              <div>
                <label for="email-path" class="block text-sm font-medium text-gray-700">Return-path email</label>
                <div class="mt-1  w-full">
                  <input v-model="$v.return_path_email.$model" type="text" name="email-path" id="email-path" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
                <span class="text-sm text-gray-600">
                  Leave empty to ignore it.
                </span>
              </div>
            </div>
          </div>
        </dl>
      </div>
    </div>
  </SettingsWrapper>
</template>

<script>

import SettingsWrapper from "./SettingsWrapper"
import websitePropertiesHelper from "@/components/SideEditor/website-properties-helper"

export default {
  components: {
    SettingsWrapper,
  },
  mixins: [
    websitePropertiesHelper({
      success: "Successfully saved SMTP settings!",

      key: "smtp",
      fieldMap: {
        host: "smtp/configuration_option/host",
        port: "smtp/configuration_option/port",
        protocol: "smtp/configuration_option/protocol",
        authentication_type: "smtp/configuration_option/authentication",
        username: "smtp/configuration_option/username",
        password: "smtp/configuration_option/password",
        return_path_email: "smtp/configuration_option/return_path_email",
      },
      defaultDataValues: {
        protocol: "ssl",
        authentication_type: "login",
      },
    }),
  ],
}

</script>
